<template>
  <div class="container-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ContainerBox',
}
</script>

<style lang="less" scoped>
.container-box {
  min-height: 50vh;
  background-image: url("@/assets/member/ContainerBox_bg_1.png"),
    url("@/assets/member/ContainerBox_bg_3.png"), url("@/assets/member/ContainerBox_bg_2.png");
  background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: center top, center bottom, center center;
  background-size: 100%;
  overflow: auto;
  padding: 60px 50px;
  box-sizing: border-box;
}

</style>
